/**
 * Values safe to pass into console.error / JSON.stringify so DevTools and React dev
 * do not call String() on nested objects (e.g. Firestore errors with non-string `message`).
 */

export function safeStrForConsole(v: unknown): string {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  try {
    if (typeof v === 'object') {
      try {
        return JSON.stringify(v);
      } catch {
        return '—';
      }
    }
    return String(v);
  } catch {
    return '—';
  }
}

export function getErrorDebugPayloadForConsole(err: unknown): {
  name: string;
  code: string;
  message: string;
  stack: string;
  serialized: string;
} {
  const asAny = err as Record<string, unknown> | null | undefined;
  let serialized = '';
  try {
    if (asAny && typeof asAny === 'object') {
      serialized = JSON.stringify(asAny, Object.getOwnPropertyNames(asAny));
    } else {
      serialized = safeStrForConsole(err);
    }
  } catch {
    serialized = '[unserializable error]';
  }
  const pick = (key: string): string => {
    if (!asAny || typeof asAny !== 'object' || !(key in asAny)) return '';
    return safeStrForConsole(asAny[key]);
  };
  return {
    name: pick('name'),
    code: pick('code'),
    message: pick('message'),
    stack: pick('stack'),
    serialized,
  };
}
